<div fxLayout="row" fxLayoutAlign="center center" [class]="getClass()" style="height:100%; padding: 20px">

    <div fxFlex="70" style="font-size: medium">{{ configuration.assesmentQuestion }}</div>
    
    <div fxFlex="15" fxLayoutAlign="center center">
        <button [style.background-color]="configuration.assesmentPositiveButtonBackgroundColor" type="button" mat-icon-button (click)="likeClicked()">
            <mat-icon>{{ configuration.assessmentPositiveButtonIcon }}</mat-icon>
        </button>
    </div>

    <div fxFlex="15" fxLayoutAlign="center center">
        <button [style.background-color]="configuration.assesmentNegativeButtonBackgroundColor" type="button" mat-icon-button (click)="dislikeClicked()">
            <mat-icon>{{ configuration.assessmentNegativeButtonIcon }}</mat-icon>
        </button>
    </div>

</div>